import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { browserHistory } from 'react-router';

import {
  Button,
  View,
 } from 'components';

export default class NotFound extends Component {

  /* Handlers */

  backbuttonHandler() {
    browserHistory.goBack();
  }

  /* Render */

  render() {
    return (
      <View
        backbutton={this.backbuttonHandler}
        title="errors.page.title"
      >
        <div className="u-text-center">
          <div className="offset">
            <FormattedMessage id="errors.page.description" />
          </div>
          <div className="offset offset--md">
            <Button
              className="button button-bg-yellow button-regular"
              onClick={this.backbuttonHandler}
              text="actions.back"
            />
          </div>
        </div>
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./js/views/404/index.jsx